(function () {
  'use strict';

  // === COLLECTION FILTERS IMPROVEMENTS ===
  // Nuclear Strategy: We kill all theme overlays via CSS and handle everything via pure JS delegated listeners.
  (function () {
    const isParent = (el) => el && el.tagName === 'DETAILS' && (el.classList.contains('facets__dropdown') || el.classList.contains('mobile-facets__disclosure'));
    const isNested = (el) => el && el.tagName === 'DETAILS' && (el.classList.contains('facets__disclosure') || el.classList.contains('mobile-facets__details'));

    // 1. Click-Outside: Handle via window listener since we disabled the CSS overlays
    window.addEventListener('mousedown', (e) => {
      const openFilters = document.querySelectorAll('details.facets__dropdown[open], details.mobile-facets__disclosure[open]');
      openFilters.forEach(filter => {
        if (!filter.contains(e.target)) {
          filter.removeAttribute('open');
          const s = filter.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    }, true);

    // 2. Accordion: Switch categories in one click + State Management
    window.addEventListener('click', (e) => {
      const summary = e.target.closest('details > summary');
      if (!summary) return;
      const details = summary.parentElement;
      
      // Handle Nested Accordion
      if (isNested(details)) {
        if (!details.open) {
          // It's closed, we want to open it and close siblings
          e.preventDefault();
          e.stopImmediatePropagation();
          
          const container = details.closest('.facets__dropdown, .mobile-facets__main');
          if (container) {
            container.querySelectorAll('details[open]').forEach(d => {
              if (isNested(d)) {
                d.removeAttribute('open');
                const s = d.querySelector('summary');
                if (s) s.setAttribute('aria-expanded', 'false');
              }
            });
          }
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      // Handle Parent State Cleanup
      if (isParent(details) && details.open) {
        // If clicking the parent summary while it's open (to close it)
        // We let it close, but the 'toggle' listener below handles the cleanup.
      }
    }, true);

    // 3. State Cleanup: Reset children when parent closes
    window.addEventListener('toggle', (e) => {
      const d = e.target;
      if (isParent(d) && !d.open) {
        d.querySelectorAll('details[open]').forEach(child => {
          child.removeAttribute('open');
          const s = child.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        });
      }
    }, true);

    // iOS Compatibility
    if ('ontouchstart' in window) {
      document.body.style.cursor = 'pointer';
    }
  })();

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function getLocalDateString(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function parseDateString(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length !== 3) return null;
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
  }

  function daysBetween(start, end) {
    var msPerDay = 24 * 60 * 60 * 1000;
    return Math.floor((end - start) / msPerDay);
  }

  function shouldHide(value, todayValue, hideDays) {
    var storedDate = parseDateString(value);
    var todayDate = parseDateString(todayValue);
    if (!storedDate || !todayDate) return false;
    var diff = daysBetween(storedDate, todayDate);
    return diff >= 0 && diff < hideDays;
  }

  function getStorage() {
    try {
      if (window.localStorage) return window.localStorage;
    } catch (error) {
      return null;
    }
    return null;
  }

  onReady(function () {
    var popup = document.querySelector('[data-kp-popup]');
    if (!popup) return;

    if (popup.getAttribute('data-enabled') === 'false') return;

    var delaySeconds = parseInt(popup.getAttribute('data-delay-seconds'), 10);
    if (isNaN(delaySeconds)) delaySeconds = 10;

    var hideDays = parseInt(popup.getAttribute('data-hide-days'), 10);
    if (isNaN(hideDays) || hideDays < 1) hideDays = 1;

    var storage = getStorage();
    var today = getLocalDateString(new Date());
    var shownKey = 'kp_newsletter_shown_date';
    var dismissedKey = 'kp_newsletter_dismissed_date';
    var savedEmailKey = 'kp_newsletter_email';

    var shownDate = storage ? storage.getItem(shownKey) : null;
    var dismissedDate = storage ? storage.getItem(dismissedKey) : null;

    if (shouldHide(shownDate, today, hideDays) || shouldHide(dismissedDate, today, hideDays)) {
      return;
    }

    var closeTriggers = popup.querySelectorAll('[data-kp-popup-close]');
    var emailForm = popup.querySelector('[data-kp-mailchimp-form]');
    var smsForm = popup.querySelector('[data-kp-sms-form]');
    var emailInput = popup.querySelector('[data-kp-email-input]');
    var phoneInput = popup.querySelector('[data-kp-phone-input]');
    var emailHiddenInput = popup.querySelector('[data-kp-email-hidden]');
    var emailMessage = popup.querySelector('[data-kp-popup-message]');
    var smsMessage = popup.querySelector('[data-kp-sms-popup-message]');
    var noThanksButton = popup.querySelector('.kp-newsletter-popup__no-thanks');
    var stepEmail = popup.querySelector('[data-kp-popup-step="email"]');
    var stepSms = popup.querySelector('[data-kp-popup-step="sms"]');
    var smsStepEnabled = popup.getAttribute('data-enable-sms-step') !== 'false' && !!stepSms;
    var emailSubmitButton = emailForm ? emailForm.querySelector('.kp-newsletter-popup__submit') : null;
    var emailOnlySuccessText = 'Thank you! Your email has been submitted.';
    var bodyOpenClass = 'kp-newsletter-open';
    var lastFocused = null;

    function setStep(stepName) {
      var showSmsStep = stepName === 'sms';
      if (stepEmail) {
        stepEmail.classList.toggle('is-active', !showSmsStep);
        stepEmail.setAttribute('aria-hidden', showSmsStep ? 'true' : 'false');
      }
      if (stepSms) {
        stepSms.classList.toggle('is-active', showSmsStep);
        stepSms.setAttribute('aria-hidden', showSmsStep ? 'false' : 'true');
      }
      if (showSmsStep && phoneInput) {
        phoneInput.focus();
      }
    }

    function setSmsEmailValue(value) {
      if (!emailHiddenInput) return;
      emailHiddenInput.value = value || '';
    }

    function getCurrentEmailValue() {
      if (!emailInput || !emailInput.value) return '';
      return emailInput.value.trim();
    }

    function getStoredEmailValue() {
      if (!storage) return '';
      var storedEmail = storage.getItem(savedEmailKey);
      return storedEmail ? storedEmail.trim() : '';
    }

    function getEmailForSmsSubmission() {
      if (emailHiddenInput && emailHiddenInput.value) {
        return emailHiddenInput.value.trim();
      }

      var currentEmail = getCurrentEmailValue();
      if (currentEmail) return currentEmail;

      return getStoredEmailValue();
    }

    if (!smsStepEnabled && emailForm && emailMessage && emailSubmitButton) {
      emailForm.insertBefore(emailMessage, emailSubmitButton);
    }

    function openPopup() {
      if (popup.classList.contains('is-visible')) return;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add(bodyOpenClass);

      if (storage) storage.setItem(shownKey, today);

      setStep('email');
      if (emailMessage) emailMessage.classList.remove('is-visible');
      if (smsMessage) smsMessage.classList.remove('is-visible');
      if (noThanksButton) noThanksButton.classList.remove('is-hidden');

      lastFocused = document.activeElement;
      if (emailInput) emailInput.focus();
    }

    function closePopup(setDismissed) {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(bodyOpenClass);

      if (setDismissed && storage) storage.setItem(dismissedKey, today);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    closeTriggers.forEach(function (button) {
      button.addEventListener('click', function () {
        var shouldDismiss = button.hasAttribute('data-kp-popup-dismiss');
        closePopup(shouldDismiss);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.classList.contains('is-visible')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup(false);
      }
    });

    if (emailForm) {
      emailForm.addEventListener('submit', function (event) {
        if (typeof emailForm.checkValidity === 'function' && !emailForm.checkValidity()) {
          event.preventDefault();
          emailForm.reportValidity();
          return;
        }

        var action = emailForm.getAttribute('action');
        if (!action) {
          event.preventDefault();
          if (emailMessage) {
            emailMessage.textContent = 'Mailchimp email form action URL is missing.';
            emailMessage.classList.add('is-visible');
          }
          return;
        }

        var submittedEmail = getCurrentEmailValue();
        if (!submittedEmail) {
          event.preventDefault();
          if (emailInput && typeof emailInput.reportValidity === 'function') {
            emailInput.reportValidity();
          }
          return;
        }

        setSmsEmailValue(submittedEmail);
        if (storage) storage.setItem(savedEmailKey, submittedEmail);
        if (storage) storage.setItem(dismissedKey, today);

        if (smsStepEnabled) {
          if (emailMessage) emailMessage.classList.add('is-visible');
          if (noThanksButton) noThanksButton.classList.add('is-hidden');
          setStep('sms');
        } else {
          if (emailMessage) {
            emailMessage.textContent = emailOnlySuccessText;
            emailMessage.classList.add('is-visible');
          }
          if (noThanksButton) noThanksButton.classList.remove('is-hidden');
        }
      });
    }

    if (smsForm) {
      smsForm.addEventListener('submit', function (event) {
        if (typeof smsForm.checkValidity === 'function' && !smsForm.checkValidity()) {
          event.preventDefault();
          smsForm.reportValidity();
          return;
        }

        var action = smsForm.getAttribute('action');
        if (!action) {
          event.preventDefault();
          if (smsMessage) {
            smsMessage.textContent = 'Mailchimp SMS form action URL is missing.';
            smsMessage.classList.add('is-visible');
          }
          return;
        }

        var emailFromStepOne = getEmailForSmsSubmission();
        if (!emailFromStepOne) {
          event.preventDefault();
          if (smsMessage) {
            smsMessage.textContent = 'Email from step 1 is missing. Please reload and submit email again.';
            smsMessage.classList.add('is-visible');
          }
          return;
        }

        setSmsEmailValue(emailFromStepOne);
        if (storage) storage.setItem(savedEmailKey, emailFromStepOne);
        if (storage) storage.setItem(dismissedKey, today);
        if (smsMessage) smsMessage.classList.add('is-visible');
      });
    }

    window.setTimeout(openPopup, Math.max(0, delaySeconds) * 1000);
  });


  onReady(function () {
    if (!document.body.classList.contains('template-product')) return;

    function activateProductVideos(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var selector = '.product-media-container.media-type-video, .product-media-container.media-type-external_video';
      var containers = [];

      if (root.matches && root.matches(selector)) {
        containers.push(root);
      }

      root.querySelectorAll(selector).forEach(function (container) {
        containers.push(container);
      });

      containers.forEach(function (container) {
        var posterButton = container.querySelector('.deferred-media__poster');
        if (posterButton && !container.hasAttribute('data-kp-video-activated')) {
          container.setAttribute('data-kp-video-activated', 'true');
          posterButton.click();
        }

        var video = container.querySelector('video');
        if (video) {
          video.muted = true;
          video.loop = true;
          video.autoplay = true;
          video.setAttribute('muted', 'muted');
          video.setAttribute('playsinline', 'playsinline');

          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }

        var iframe = container.querySelector('iframe');
        if (iframe) {
          var src = iframe.getAttribute('src') || '';
          if (src && src.indexOf('autoplay=1') === -1) {
            var separator = src.indexOf('?') === -1 ? '?' : '&';
            iframe.setAttribute('src', src + separator + 'autoplay=1&loop=1&mute=1&playsinline=1');
          }
        }
      });
    }

    activateProductVideos(document);

    if (typeof MutationObserver !== 'undefined') {
      var productRoot = document.getElementById('MainContent') || document.querySelector('main');
      if (productRoot) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (!node || node.nodeType !== 1) return;
              activateProductVideos(node);
            });
          });

          activateProductVideos(productRoot);
        });

        observer.observe(productRoot, { childList: true, subtree: true });
      }
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.product__thumbnail, .thumbnail, .slider-button, .product__media-toggle')) {
        return;
      }

      window.setTimeout(function () {
        activateProductVideos(document);
      }, 120);
    });
  });

})();
